// @ts-ignore
export const BATCH_DOMAIN = import.meta.env.ROOT_REACT_APP_BATCH_DOMAIN || window.location.host;
// Where the API is reached: the same-origin /api worker proxy in every deployed environment. Only a local
// setup without that proxy sets these, to a backend's own origin. The service and version are added in core/api.
// @ts-ignore
export const API_ROOT = import.meta.env.ROOT_REACT_APP_API_ROOT || '/api';
// @ts-ignore
export const AUTH_API_ROOT = import.meta.env.ROOT_REACT_APP_AUTH_API_ROOT || API_ROOT;

// @ts-ignore
export const TURNSTILE_SITE_KEY = import.meta.env.ROOT_REACT_APP_TURNSTILE_SITE_KEY as string | undefined;

